import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FuseCardComponent } from '@fuse/components/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf, NgFor, isPlatformBrowser, CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { FooterComponent } from 'app/modules/landing/footer/footer.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { ICustomer, IInvoices, IResponse, IStatementsArray } from 'app/core/shared-services/shared-interface.types';
import { PaymentMethodComponent } from 'app/modules/financials/payment-methods/payment-methods.component';
import { FuseAlertType } from '@fuse/components/alert';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { MatDatepickerModule, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  standalone: true,
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss'],
  imports: [
          FuseCardComponent, MatButtonModule, PaymentMethodComponent, MatFormFieldModule, ReactiveFormsModule, 
          FormsModule, NgIf, NgFor, MatInputModule, FooterComponent, MatIconModule, SharedMethodsModule, 
          MatSlideToggleModule, MatSelectModule, DatePipe, CurrencyPipe, MatDatepickerModule, RouterLink, MatSelectModule,
          NgxDocViewerModule, MatProgressSpinnerModule, RouterLink, CommonModule, MatPaginatorModule, MatTableModule, MatDividerModule]
})
export class InvoicesComponent implements OnInit {
 
 
  @ViewChild('matPaginator') matPaginator: MatPaginator;

  public invoices: IInvoices;
  public statements: IStatementsArray;
  public userAccount: ICustomer;
  public invoiceBlob: any;
  public statementBlob: any;
  public payNowResult: any;
  public alert: { type: FuseAlertType; message: string };
  public loading: boolean = false;
  public isScreenSmall: boolean;
  public showAlert: boolean = false;
  public loadingStatements: boolean = false;
  public selectedButton: string = 'details';
  public documentLink: any;
  public pdfLoading: boolean;
  public pageSize: number = 6;
  public pagedInvoices: any = [];
  public pagedStatements: any = [];
  public isExpanded: boolean;
  public loadingMap: { [docId: string]: boolean } = {};
  public hideViewMore: boolean;

  private statementsResult: any;
  private invoicesResult: any;
  private referrer: string;

  //Statements
  public selectedDateRange: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  public currentUrl: string;

  constructor(
    private _sharedMethods: SharedMethodsModule,
    private dialog: MatDialog,
    private router: Router,
    private _gtmService: GtmService,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _activatedRoute: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
  }

  async ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {

      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }

        const route = window.location.href;
        const path = this.router.url;

        this._gtmService.forgotPasswordPageReferrer = route;

        this._gtmService.pushEvent({ 
          event: 'page_view',
          page_url: route,
          page_path: path,
          page_title: 'invoices_page',
          page_referrer: this.referrer ? this.referrer : route
        });
      }

    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(({matchingAliases}) =>
    {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
    });

    this.selectButton('billing');
    this.userAccount = (await this._sharedMethods.getCustomerAccount()).result;

    // get customer invoices
    this.invoicesResult = await this._sharedMethods.getCustomerInvoices();
    this.invoices = this.invoicesResult?.result?.sort((a, b) => new Date(b.DocumentDate).getTime() - new Date(a.DocumentDate).getTime());
    

    // get customer statements
    this.statementsResult = await this._sharedMethods.getCustomerStatements(this.userAccount?.EntityAccountEntityID, 'Sent');
    const statements = this.statementsResult.result?.value;
    this.statements = statements
    .filter(x => x.Status !== 'Failed')
    ?.sort((a, b) => new Date(b.FromDate).getTime() - new Date(a.FromDate).getTime());
    

    this.setPagedInvoices(0, 6);
    this.setPagedStatements(0, 6);

  }

  public async onStatementChange(event: any) {
    this.loadingStatements = true;
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    let from, to;

    switch (event.value) {
      case 'currentMonth':
        from = new Date(year, month, 1);
        to = today;
        break;
  
      case 'lastMonth':
        from = new Date(year, month - 1, 1);
        to = new Date(year, month, 0); // last day of previous month
        break;
  
      case '0-3Months':
        from = new Date(year, month - 3, 1);
        to = today;
        break;
  
      case '3-6Months':
        from = new Date(year, month - 6, 1);
        to = new Date(year, month - 3, 0);
        break;
  
      case '6-12Months':
        from = new Date(year, month - 12, 1);
        to = new Date(year, month - 6, 0);
        break;
  
      default:
        throw new Error("Invalid period specified");
    }

    const formatDate = (date) =>
      date.toLocaleDateString('en-ZA', { year: 'numeric', month: 'long', day: 'numeric' });
  
    // return {
    //   FromDate: formatDate(from),
    //   ToDate: formatDate(to),
    // };

    const generateStatementResponse = await this._sharedMethods.generateStatement(formatDate(from), formatDate(to), this.userAccount?.EntityAccountEntityID);
    if(generateStatementResponse.success) {
      this.statementsResult = await this._sharedMethods.getCustomerStatements(this.userAccount?.EntityAccountEntityID, 'Sent');
      const statements = this.statementsResult.result.value;
      this.statements = statements
      .filter(x => x.Status !== 'Failed')
      .sort((a, b) => new Date(b.Audit_CreatedDate).getTime() - new Date(a.Audit_CreatedDate).getTime());
      this.setPagedStatements(0, 6);
      this.loadingStatements = false;
      this.selectedDateRange = event.value;
    } else {
      this.loadingStatements = false;
    }
  }
  
  public selectButton(button: string) {
    this.selectedButton = button;
  }
  
 
  public async viewInvoice(id: number) {
    if (isPlatformBrowser(this.platformId)) {
      this.invoiceBlob = await this._sharedMethods.getInvoiceById(id);
      const url = window.URL.createObjectURL(new Blob([this.invoiceBlob.result]))
      const link = document.createElement('a')
      link.href = url
      
    }
  }
  
  

  public async downloadDocument(
    entity: any,
    type: 'statement' | 'invoice',
    idKey: string,
    downloadMethod: (id: any) => Promise<any>
  ) {
    const id = entity[idKey];
    const date = new Date(entity.FromDate ?? entity.DocumentDate);
    const month = date.toLocaleString('en-US', { month: 'long' });
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    const readableDate = `${month}_${day}_${year}`;
  
    this.loadingMap[id] = true;
  
    if (isPlatformBrowser(this.platformId)) {
      const blobResponse = await downloadMethod.call(this._sharedMethods, id);
      const url = window.URL.createObjectURL(new Blob([blobResponse.result]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${type.charAt(0).toUpperCase() + type.slice(1)}_${readableDate}.pdf`);
      document.body.appendChild(link);
      link.click();
    }
  
    this.loadingMap[id] = false;
  }
  
  
  public async payInvoice(id: number, amount: number) {
    this.loading = true;
    const payNowData = {
      EntityAccountID: this.userAccount?.EntityAccountEntityID,
      pendingAmount: amount,
      isPartialPayment: false,
      partialAmount: null,
      isForCardTokenisation: false
    }
    this.payNowResult = await this._sharedMethods.payNow(payNowData);
    if (this.payNowResult) {
      if (this.payNowResult?.success && isPlatformBrowser(this.platformId)) {
        // only using payfast for now
        window.open(this.payNowResult.result[0].PaymentLink, '_top');
      } 
    } else {
      Swal.fire({
        title: 'Error!',
        text: `${this.payNowResult}`,
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'OKAY',
        showConfirmButton: true,
        customClass: {
          htmlContainer: 'text-lg',
          confirmButton: 'custom-button text-md',
        }
      }).then(() => {
        location.reload();
      })
    }
    //   this.alert = {
      //     type: 'error',
      //     message: this.payNowResult.error.error.Message,
      //   }
      //   this.showAlert = true;
      // }
    }
    
    public async addEvent(dateRangeStart: any, dateRangeEnd: any) {
      if (dateRangeStart.value && dateRangeEnd.value) {
        let toDate: any = new Date(dateRangeEnd.value).toISOString().slice(0,10);
        let fromDate: any = new Date(dateRangeStart.value).toISOString().slice(0,10);
        const entityAccountID = this.userAccount?.EntityAccountEntityID;
        
        //Send statement via email
        await this._sharedMethods.emailStatement(entityAccountID, null, fromDate, toDate).then(res => {
          if(res.success) {
            Swal.fire({
              title: 'Statement sent via email',
              icon: 'success',
              showCancelButton: true,
              cancelButtonText: 'Close',
              confirmButtonText: 'Download Statement',
              customClass: {
                htmlContainer: 'text-lg',
                confirmButton: 'custom-button text-md bg-primary text-white rounded-full',
                cancelButton: 'custom-button text-md bg-brown text-white rounded-full',
              }
              
            }).then(()=>{
              this.closeDialog();
              this.downloadDocument(res.result, 'statement', 'EntityAccountStatementHistoryID', this._sharedMethods.downloadStatement);
          });
        }else{
          Swal.fire({
            title: 'Error sending statement via email',
            text: `${res.error?.statusText}`,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: 'Confirm',
            customClass: {
              htmlContainer: 'text-lg',
              confirmButton: 'custom-button text-md bg-primary text-white rounded-full',
            }
          });
        }
      });
      
    }
  }




 

  public async openViewPDFDialog(templateRef: any, id: any) {
    
    if (isPlatformBrowser(this.platformId)) {
      this.pdfLoading = true;
      this.dialog.open(templateRef, {
        width: '700px',
        height: '95%',
        backdropClass: 'blurModalBackground',
      });
      this.invoiceBlob = await this._sharedMethods.getInvoiceById(id)
      this.documentLink = window.URL.createObjectURL(new Blob([this.invoiceBlob.result], { type: 'application/pdf' }));
      this.pdfLoading = false;
    }
  }
  
  public closeDialog() {
    this.dialog.closeAll();
  }
  
  /**
   * On destroy
  */
 ngOnDestroy(): void
 {
   // Unsubscribe from all subscriptions
   this._unsubscribeAll.next(null);
      this._unsubscribeAll.complete();
  }

      
  /**
   * Do check
  */
  ngDoCheck() {
    if (this.currentUrl !== this._activatedRoute.snapshot['_routerState'].url) {
      this.currentUrl = this._activatedRoute.snapshot['_routerState'].url;
      this.queryParamCheck();
    }
  }
    
  private queryParamCheck() {
    const qP = this._activatedRoute.snapshot.queryParamMap.get('segment')
    if (qP) {
      this.selectButton(qP);
      this._changeDetectorRef.detectChanges();
    }
  }

  isPaid(i: any): boolean {
    return i.Paid === true;
    
  }
  
  isOverdue(i: any): boolean {
    const dateOver = new Date(i.DueDate) < new Date();
    const isPaid = i.Paid;
    if(dateOver && !isPaid){
      return true
    }   
  }
  
  isPending(i: any): boolean {
    const dateOver = new Date(i.DueDate) < new Date();
    const isPaid = i.Paid;
    if(!dateOver && !isPaid){
      return true
    }   
  }

  getStatusLabel(i: any): string {
    if (this.isPaid(i)) {
      return 'Paid';
    } else if (this.isOverdue(i)) {
      return 'Overdue';
    } else if (this.isPending(i)) {
      return 'Pending';
    }
    return 'Unknown';
  }


 
  
  public setPagedInvoices(pageIndex: number, pageSize: number) {
    this.isExpanded = this.isExpanded;
    const start = pageIndex * pageSize;
    const end = start + pageSize;
    this.pagedInvoices = this.invoices?.slice(start, end);
  }

  public setPagedStatements(pageIndex: number, pageSize: number) {
    this.isExpanded = this.isExpanded;
    const start = pageIndex * pageSize;
    const end = start + pageSize;
    this.pagedStatements = this.statements
    ?.sort((a, b) => new Date(b.Audit_CreatedDate).getTime() - new Date(a.Audit_CreatedDate).getTime()) // newest first
    .slice(start, end);
  }


  public clearDateRange(){
    this.hideViewMore = false;
    this.setPagedStatements(0, 6);
    this.setPagedInvoices(0, 6);
  }


  
  public async filterInvoicesStatements(dateRangeStart: any, dateRangeEnd: any, type: string) {
 
    if (dateRangeStart.value && dateRangeEnd.value) {
      this.hideViewMore = true;
      const pad = (n: number) => (n < 10 ? '0' + n : n);
      const formatLocalDate = (date: Date) =>
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
      
      const fromDate = formatLocalDate(new Date(dateRangeStart.value));
      const toDate = formatLocalDate(new Date(dateRangeEnd.value));

      switch (type) {
        case "statement":
          this.pagedStatements = this.statements.filter((statement) => {
            const invoiceDate = new Date(statement.FromDate).toISOString().slice(0, 10);
            return invoiceDate >= fromDate && invoiceDate <= toDate;
          })?.sort((a, b) => new Date(b.FromDate).getTime() - new Date(a.FromDate).getTime());
          break;
        case "invoices":
          this.pagedInvoices = this.invoices.filter((invoice) => {
            const invoiceDate = new Date(invoice.DocumentDate).toISOString().slice(0, 10);
            return invoiceDate >= fromDate && invoiceDate <= toDate;
          })?.sort((a, b) => new Date(b.DocumentDate).getTime() - new Date(a.DocumentDate).getTime());
      
          break;
      }
      
  }
}

}

